<template>
  <div>
    <PageTitle title="Order Food & Product Reports" />
    <v-container fluid class="lighten-12">
      <v-row>
        <v-col cols="12" md="12" class="pa-3">
          <v-card class>
            <v-tabs v-model="tab" background-color="white" color="#24303a" slider-color="#24303a">
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-for="item in items" :key="item.tab">
                {{ item.tab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.tab">
                <OrderFoodReport v-if="item.tab === 'Food Report'" />
                <OrderProductReport v-if="item.tab === 'Product Report'" />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import OrderFoodReport from "./OrderFoodReport";
import OrderProductReport from "./OrderProductReport"

export default {
  data() {
    return {
      items: [
        { tab: "Food Report", content: "this is credit tab" },
        { tab: "Product Report", content: "this is credit tab" },
      ],
       tab: "Credit",
    };
  },
  components: {
      OrderFoodReport,
      OrderProductReport,
  },
};
</script>
